import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ClearIcon from '@material-ui/icons/Backspace'
import red from '@material-ui/core/colors/red'
import _ from 'lodash'
export default class NumComponent extends Component {
  static propTypes = {
    value: PropTypes.any,
    disabled: PropTypes.bool,
    type: PropTypes.string, // number, reduction, double
    onClick: PropTypes.func
  }

  static defaultProps = {
    label: 'none',
    disabled: false
  }

  handleClick = () => {
    this.props.onClick(this.props.value.toString(), this.props.type)
  }

  render() {
    const { value } = this.props
    let content = null
    if (_.isNumber(value)) {
      content = <Typography variant="subheading">{value}</Typography>
    } else if (value === '<') {
      content = <ClearIcon style={{ color: red[500] }} color="inherit" />
    } else if (value === '.00') {
      content = <Typography variant="subheading">{value}</Typography>
    }
    return (
      <Grid container justify="center" alignItems="center" spacing={16}>
        <Button
          disabled={value !== '<' ? this.props.disabled : false}
          variant="fab"
          onClick={this.handleClick}>
          {content}
        </Button>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/numPad/NumComponent.js